import React, { useEffect, useState } from "react";
import { callAPI } from "../../../axios";
import { CircularProgress, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { exceptionalProducts } from './ProductTag'
import { getChainIdLS } from "../../../utils/utils";

const PackDetails = (props) => {

    const {sid, cdsn, flag} = props
    const [cdsnPackDetails, setCdsnPackDetails] = useState({});
    const [loader, setLoader] = useState(false);

    const [packDetailsFetchNowLoader, setPackDetailsFetchNowLoader] = useState(false)

    const triggerFetchNow = ()=>{
        setPackDetailsFetchNowLoader(true)
        callAPI(`/fetch?sid=${sid}&cdsn=${cdsn}&pageTitle=Packs details`, "GET", {}, { chainId: getChainIdLS() })
            .then(function (response) {
                setCdsnPackDetails(response)
                setPackDetailsFetchNowLoader(false)
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setPackDetailsFetchNowLoader(false)
            });
    }

    useEffect(() => {
        if (sid !== "" && cdsn !== "") {
            setLoader(true);
            callAPI(`/cdsn-info?sid=${sid}&cdsn=${cdsn}&pageTitle=Packs details`, "GET", {}, { chainId: getChainIdLS() })
                .then(function (response) {
                    setCdsnPackDetails(response);
                    setLoader(false);
                })
                .catch(function (error) {
                    console.warn(error.response?.data?.errorMessage);
                    setLoader(false);
                });
        }
    }, [sid, cdsn, flag])

    return (
        <div className="cdsn-details-admin-level">
            {loader && <div className="circular-progress"><CircularProgress /></div>}
            <div className="flex-items-between">
                <p className="mb-0"><b>Pack Details </b> 
                (Last Updated: {dayjs(cdsnPackDetails.lastUpdated).format("DD MMM YYYY | hh:mm A")})
                </p>
                <div className="d-flex">
                    {packDetailsFetchNowLoader && <p className="text-danger mx-1 mb-0 mt-2">* Fetch Now in Progress. Leaving the page will interrupt current fetch now.</p>}
                    <button type="button" className="create-btn me-2 opacity-50 pe-none">Sync Data</button>
                    <Tooltip title={`${packDetailsFetchNowLoader ? "Fetch Now in Progress" : "Fetch Now"}`} arrow>
                            <button onClick = {triggerFetchNow}  type="button" className={`${packDetailsFetchNowLoader?"opacity-50 pe-none":""} create-btn me-2`}>
                                {packDetailsFetchNowLoader?<img
                                src="/Images/rotate.png"
                                width="25"
                                className="loaderIcon mr-1"
                                />:""} Fetch Now </button>
                    </Tooltip>
                </div>
            </div>
            <div className="dth-end">
                <div className="cd-ids-container">
                    <p><strong>Box End</strong> : <span> CA ID's - {cdsnPackDetails.boxEnd?.packageId.length > 0 ? cdsnPackDetails.boxEnd?.packageId.length : 'N.A'}</span></p>
                    <p>Subscribe:<span className={`${cdsnPackDetails.boxEnd?.status ? 'active-color' : 'inactive-color'}`}> {cdsnPackDetails.boxEnd?.status === undefined ? "N.A" : cdsnPackDetails.boxEnd?.status ? 'Active' : 'In-Active'}</span></p>
                </div>
                <div className="ca-ids">
                    {
                        cdsnPackDetails.boxEnd?.packageId.map((item, index) => (
                            <span className={`${cdsnPackDetails.itEnd?.packageId?.includes(item.toString()) ? "" : "text-pink"
                                }
                        ${cdsnPackDetails.casEnd?.packageId?.includes(item.toString()) ? "" : " text-pink"
                                }
                         ${exceptionalProducts?.includes(parseInt(item)) ? " text-purple" : ""
                                }`} key={item}>{index ? ', ' : ''}{item}</span>
                        ))
                    }
                </div>
            </div>
            <div className="ca-end">
                <div className="cd-ids-container"> 
                    <p><strong>IT/SMS</strong> : <span> CA ID's - {[...new Set(cdsnPackDetails.itEnd?.packageId?.sort((a, b) => a - b))].length > 0 ? [...new Set(cdsnPackDetails.itEnd?.packageId?.sort((a, b) => a - b))].length : 'N.A'}</span></p>
                    <p>Subscribe:<span className={`${cdsnPackDetails.itEnd?.status ? 'active-color' : 'inactive-color'}`}> {cdsnPackDetails.itEnd?.status === undefined ? "N.A" : cdsnPackDetails.itEnd?.status ? 'Active' : 'In-Active'}</span></p>
                </div>
                <div className="ca-ids">
                    {[...new Set(cdsnPackDetails.itEnd?.packageId?.sort((a, b) => a - b))]?.length === 0 ? (
                        <span className="Roboto-Regular">No IT/SMS ID'S Available</span>
                    ) : ([...new Set(cdsnPackDetails.itEnd?.packageId?.sort((a, b) => a - b))]?.sort((a, b) => a - b).map((item, index) => (
                        <span className={`${exceptionalProducts?.includes(parseInt(item)) ? "text-purple " : ""
                            } ${cdsnPackDetails.boxEnd?.packageId?.includes(item) ? "" : "text-pink"
                            } ${cdsnPackDetails.casEnd?.packageId?.includes(item) ? "" : " text-pink"
                            }`} key={item}>{index ? ', ' : ''}{item}</span>
                    )))
                    }
                </div>
            </div>
            <div className="it-end">
                <div className="cd-ids-container">
                    <p><strong>CA System</strong> : <span> CA ID's - {cdsnPackDetails.casEnd?.packageId.length > 0 ? cdsnPackDetails.casEnd?.packageId.length : 'N.A'}</span></p>
                    <p>Subscribe:<span className={`${cdsnPackDetails.casEnd?.status ? 'active-color' : 'inactive-color'}`}> {cdsnPackDetails.casEnd?.status === undefined ? "N.A" : cdsnPackDetails.casEnd?.status ? 'Active' : 'In-Active'}</span></p>
                </div>
                <div className="ca-ids">
                    {cdsnPackDetails.casEnd?.packageId?.length === 0 ? (
                        <span className="Roboto-Regular">No CA System ID'S Available</span>
                    ) : (
                        cdsnPackDetails.casEnd?.packageId?.sort((a, b) => a - b).map((item, index) => (
                            <span className={`${cdsnPackDetails.itEnd?.packageId?.includes(item.toString())
                                ? ""
                                : "text-pink"
                                }${cdsnPackDetails.boxEnd?.packageId?.includes(item.toString())
                                    ? ""
                                    : " text-pink"
                                }
                        ${exceptionalProducts?.includes(parseInt(item)) ? " text-purple" : ""
                                }`} key={item}>{index ? ', ' : ''}{item}</span>
                        )))
                    }
                </div>
            </div>

        </div>
    )
}

export default PackDetails;